import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/Users/yangwei/work/project/cat_help_admin/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.number.constructor";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import placeholderImg from "../pages/page-components/placeholderImg";
import { getListByIds } from "@/api/mall/goodsspu";
export default {
  data: function data() {
    return {
      noPic: require("../assets/images/icon/img_pic@2x.png"),
      goodsList: [],
      initData: true
    };
  },
  components: {
    placeholderImg: placeholderImg
  },
  props: {
    theme: {
      type: Object | Array
    },
    setData: {
      type: Object | Array
    },
    cId: {
      type: Number
    },
    noEditor: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread({}, mapState({
    componentsList: function componentsList(state) {
      return state.divpageShop.componentsList;
    }
  })),
  created: function created() {},
  mounted: function mounted() {
    this.getGoodsListByIds(); //初次加载数据根据ids获取商品
  },

  methods: _objectSpread(_objectSpread({}, mapMutations(['updateData'])), {}, {
    getGoodsListByIds: function getGoodsListByIds() {
      var _this = this;
      //根据ids获取商品
      if (this.setData.goodsIds) {
        getListByIds(this.setData.goodsIds).then(function (response) {
          //如果之前的商品被删除了，那么需要自动删掉处理
          var hasGoodsIds = response.data.data.map(function (item) {
            return item.id;
          });
          var goodsIds = JSON.parse(JSON.stringify(_this.setData.goodsIds));
          goodsIds.map(function (item, index) {
            var hasIndex = hasGoodsIds.indexOf(item);
            if (hasIndex === -1) {
              _this.setData.goodsIds.splice(index, 1);
            }
          });
          var goods = new Array(_this.setData.goodsIds.length);
          response.data.data.map(function (item) {
            var index = _this.setData.goodsIds.indexOf(item.id);
            goods[index] = item;
          });
          _this.goodsList = goods;
        });
      } else {
        this.goodsList = this.setData.goodsList;
      }
    }
  }),
  watch: {
    'setData.goodsList': {
      handler: function handler(newVal, oldVal) {
        if (this.initData) {
          // setData.goodsList 初次加载的数据是缓存数据，需要舍弃掉
          this.initData = false;
        } else {
          this.goodsList = this.setData.goodsList || [];
        }
      }
    },
    componentsList: function componentsList(newVal, oldVal) {
      //添加的时候出发（解决没有移动的时候不emit数据）
      var that = this;
      that.updateData({
        componentsList: that.componentsList
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    // this.$root.Bus.$off('addHotSpot')
  }
};